// extracted by mini-css-extract-plugin
module.exports = {"reject-reason":"index__reject-reason__5W_vz","title":"index__title__1X4sJ"};